import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

// Connects to data-controller="address-form"
export default class extends Controller {
  static outlets = ["polaris-select"];
  static targets = [
    "address1Field",
    "address2Field",
    "cityField",
    "zipField",
    "provinceSelect",
  ];
  static values = { shopId: Number };

  countryChange(event) {
    const target = this.provinceSelectField.id;
    const selectedCountryCode = event.target.selectedOptions[0].value;
    this.resetAddressForm();

    get(
      `/retailer/address_field/province_options?target=${target}&country_code=${selectedCountryCode}`,
      {
        responseKind: "turbo-stream",
      },
    );
    this.polarisSelectOutlets.forEach((outlet) => outlet.update());
  }

  resetAddressForm() {
    this.address1Field.value = "";
    this.address2Field.value = "";
    this.cityField.value = "";
    this.zipField.value = "";
    this.provinceSelectField.value = "";
  }

  get provinceSelectField() {
    return this.provinceSelectTarget.querySelector("select");
  }

  get address1Field() {
    return this.address1FieldTarget.querySelector("input");
  }

  get address2Field() {
    return this.address2FieldTarget.querySelector("input");
  }

  get cityField() {
    return this.cityFieldTarget.querySelector("input");
  }

  get zipField() {
    return this.zipFieldTarget.querySelector("input");
  }
}
